import React, { useEffect, useState } from 'react';
import styles from './privacy.module.scss';
import { Button } from 'antd-mobile-v5';
import { ApiCore } from '../../../api/index';
import utils from '../../../utils/utils';

const api = new ApiCore();
function Privacy(props: any) {

    const [showUserPrivacyText, setShowUserPrivacyText] = useState(true);
    const [activeAgreeTab, setActiveAgreeTab] = useState('left');
    const [showPrivacy, setShowPrivacy] = useState(true);

    useEffect(() => {
        initData();
        return () => {
        }
    }, [])


    const initData = () => {
        const urlParms = utils.getUrlParams();
        if (urlParms.tab === 'user') {
            setActiveAgreeTab('left');
            document.title = '用户协议';
        } else {
            setActiveAgreeTab('right');
            document.title = '隐私协议';
        }
    }

    const agreeTabChange = (type: string) => {
        setActiveAgreeTab(type);
    }

    const agree = () => {
        localStorage.setItem('alk_privacy_readed', 'true');
        setShowPrivacy(false);
    }

    return (
        <div className={`${styles.privacy_content}`} style={{ display: showPrivacy ? '' : 'none' }}>
            <div className={`${styles.agree_wrap} ${styles.aggreement}`}>
                {
                    activeAgreeTab === 'left' ?
                        <div className={`${styles.aggreement_content}`}>
                            <div className={`${styles.section}`}>
                                <div className={`${styles.title} ${styles.no_indent}`}>
                                    小惠医生用户使用协议
                                </div>
                                <div className={`${styles.item}`}>
                                    您在开始使用小惠医生服务前，请您务必仔细阅读并充分理解本《小惠医生用户使用协议》。同时，您还应仔细阅读并充分理解小惠医生的隐私权政策等系列政策和声明。在本服务条款中，请您务必特别注意及重点阅读与您的权利及义务密切相关的条款，此类条款可能以粗体加黑的方式标记，包括但不限于免责条款等。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    一、使用协议的接受
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）为使您更好的使用小惠医生的相关服务，请您仔细阅读以下条款，如果您对本协议的任何条款表示异议，您可以选择不进入小惠医生。当您注册成功，无论是进入小惠医生，还是在小惠医生上发布任何内容（即「内容」），均意味着您（即「用户」）完全接受本协议项下的全部条款。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）如您未满14周岁，请在法定监护人的陪同下阅读本用户使用协议，并特别注意未成年人使用的相关条款。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）“用户”指所有直接或间接获取和使用小惠医生及相关服务的使用者，包括自然人、法人和其他组织等。在本协议中称为“用户”或称“您”。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）本协议是您与银川惠每数科互联网医院有限公司（以下简称“公司”或“我们”）之间就您注册、登录、使用“小惠医生”小程序及网页，并获得小惠医生提供的相关服务所订立的协议。公司有权依小惠医生及相关服务或运营的需要单方决定，安排或指定其关联公司、控制公司、继承公司或公司认可的第三方公司继续运营小惠医生平台。并且，就本协议项下涉及的某些服务，可能会由公司的关联公司、控制公司、继承公司或公司认可的第三方公司向您提供。您知晓并同意接受相关服务内容，即视为接受相关权利义务关系亦受本协议约束。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    二、小惠医生提供的服务
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）小惠医生作为用户的健康档案管理平台，整合线下医生及互联网医院，并提供用户卫生教育服务，将不断创新以向其用户提供最优体验。您认知并同意小惠医生提供的服务的形式和本质可不经事先通知您而不时变换。本软件及相关服务更新或部分服务内容更新后，在可能的情况下，公司将以包括但不限于系统提示、公告、站内信等方式提示用户，用户有权选择接受或拒绝更新版本或服务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）小惠医生及相关服务中包含公司以各种合法方式获取的信息或信息内容链接，同时也包括公司及其关联公司合法运营的其他单项服务。这些服务在小惠医生平台可能以单独板块形式存在。公司有权不时地增加、减少或改动这些特别板块的设置及服务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）作为这种持续创新的一部分，您认知并同意小惠医生可自行决定，无须事先通知您，即停止（永久或暂时）向您或全体用户提供服务。您可在任何时候停止使用服务。您停止使用服务时无需特别通知小惠医生。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）您认知并同意，如果小惠医生禁用对您的帐户的访问权，则您可能被阻止获得服务、您的帐户资料或包含在您帐户中的任何文件或其他内容。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （五）您认知并同意，尽管小惠医生可能目前没有设置您可通过服务发送或接收的传输数量或用于提供任何服务的存储空间的上限，但小惠医生可自行决定在任何时候设置上限。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （六）为保证小惠医生软件及相关服务安全、提升用户服务，您使用小惠医生及相关服务需自行准备与软件及相关服务有关的终端设备（如电脑、手机等装置），一旦您在其终端设备中打开小惠医生平台，即视为您使用小惠医生软件及相关服务。为充分实现小惠医生平台的全部功能，您可能需要将其终端设备联网，您理解由您承担所需要的费用（如流量费、上网费等）。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （七）您理解并同意部分服务由广告收入支持，可展示广告和推销。这些广告可能是针对存储于服务中的信息、通过服务提出的询问或其他信息的内容提供的。小惠医生在服务上的广告的方式、模式和范围可不经向您特别通知而变更。作为小惠医生授予您访问和使用服务的权利的对价，您同意小惠医生可以在服务上加载该等广告。当然您有权根据《小惠医生隐私权政策》条款的指引进行相应的推送关闭。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （八）您理解小惠医生作为服务整合平台，对于平台中第三方（比如线下医生、互联网医院等）所提供的服务并无担保及连带责任。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    三、平台使用规则
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）用户注册成功后，小惠医生将以每个用户手机号作为用户账号，该用户帐号由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）用户须对在小惠医生的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义发布任何信息；不得恶意使用注册帐号导致其他用户误认；否则小惠医生有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）用户直接或通过各类方式（如 RSS 源和站外 AdivI引用等）间接使用小惠医生服务和数据的行为，都将被视作已无条件接受本协议全部内容；若用户对本协议的任何条款存在异议，请停止使用小惠医生所提供的全部服务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）小惠医生是一个医疗健康相关信息提供、分享、传播及获取的平台，用户通过小惠医生发表的信息为公开的信息，其他第三方均可以通过小惠医生获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任；任何用户不愿被其他第三人获知的信息都不应该在小惠医生进行发表。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （五）用户承诺不得以任何方式利用小惠医生直接或间接从事违反中国法律以及社会公德的行为，小惠医生有权对违反上述承诺的内容予以删除。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （六）用户不得利用小惠医生服务制作、上载、复制、发布、传播或者转载如下内容：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 反对宪法所确定的基本原则的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 损害国家荣誉和利益的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4. 煽动民族仇恨、民族歧视，破坏民族团结的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    5. 侮辱、滥用英烈形象，否定英烈事迹，美化粉饰侵略战争行为的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    6. 破坏国家宗教政策，宣扬邪教和封建迷信的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    7. 散布谣言，扰乱社会秩序，破坏社会稳定的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    8. 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    9. 侮辱或者诽谤他人，侵害他人合法权益的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    10. 含有法律、行政法规禁止的其他内容的信息。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （七）小惠医生有权对用户使用小惠医生的情况进行审查和监督，如用户在使用小惠医生时违反任何上述规定，小惠医生或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容、暂停或终止用户使用小惠医生的权利）以减轻用户不当行为造成的影响。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （八）小惠医生保留从任何服务中筛选、审阅、标明、过滤、修订、拒绝或删除任何或所有内容的权利（但无义务这样做）。就某些服务而言，小惠医生可提供滤除明确色情内容、政治相关内容的工具。此外，还有可以通过商业渠道获得的服务和软件能够限制访问令您反感的材料。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （九）我们非常注重未成年人的保护：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 若您为未成年人，应在监护人监护、指导下仔细阅读本协议，并且使用我们的产品及/或服务已经得到监护人的同意；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 监护人应注意指导子女上网应注意的安全问题，提前做好相应的风险防范指导工作。若监护人同意未成年人使用我们的产品及/或服务，必须以监护人的名义申请消费（如涉及），并对未成年人使用我们的产品及/或服务进行正确的引导、监督。未成年人使用我们的产品及/或服务，以及行使和履行本协议项下的权利义务视为已获得了监护人的认可；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 我们尊重并保护未成年人的个人信息，对于涉及未满十四周岁未成年人用户的个人信息的处理，我们将在取得未成年人父母或监护人的同意前提下进行，具体见《小惠医生隐私权政策》第七点“我们如何处理未成年人的个人信息”；
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    四、账户安全

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）您同意并理解您有责任将您与用于获得服务的任何帐户相关的密码保密。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）您同意将独自就在您帐户下的所有活动对小惠医生负责。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）如果您得知任何对您的帐户的任何未经授权的使用，您同意立即通知小惠医生。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）关于小惠医生的数据保护惯例的信息，请查阅小惠医生的《小惠医生隐私权政策》。该政策解释了小惠医生如何处理您的个人信息，并在您使用服务时保护您的隐私。您同意按照小惠医生的隐私政策使用您的数据。


                                </div>


                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    五、知识产权
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）用户在小惠医生上发表的全部原创内容，著作权均归用户本人所有。用户可授权第三方以任何方式使用，不需要得到小惠医生的同意。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）在小惠医生上传或发表的内容，用户应保证其为权利人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权或隐私权的异议，小惠医生有权根据实际情况删除相关的内容，且有权追究用户的法律责任。给小惠医生或任何第三方造成损失的，用户应负责全额赔偿。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）如果任何第三方侵犯了小惠医生用户相关的权利，用户同意授权小惠医生或其指定的代理人代表小惠医生自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在小惠医生认为必要的情况下参与共同维权。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）小惠医生有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《中华人民共和国民法典》、《信息网络传播权保护条例》、《个人信息保护法》等法律法规及小惠医生原则对侵权信息进行处理。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （五）您认知并同意，小惠医生（或小惠医生的许可方）对服务拥有一切法定权利、所有权和利益，包括存在于服务中的任何知识产权（无论该等权利是否已经登记，也不论该等权利在世界的何等地方存在）。您进一步认知，服务可能包括小惠医生指定为保密的信息，未经小惠医生事先书面同意，您不得披露该等信息。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （六）除非您与小惠医生另有书面协议，否则本条款中的任何规定均未给予您使用小惠医生任何商号、商标、服务标记、标识、域名及其他显著品牌特征的权利。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （七）如果您在与小惠医生的单独书面协议中被给予一项使用上述品牌特征的明确的权利，则您同意您在使用该等品牌特征时遵守该协议、本条款的任何适用规定以及不时更新的小惠医生品牌特征使用指南。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （八）除本条款第（十）项规定的限制许可外，小惠医生认知并同意，其不在本条款项下获得您（或您的许可方）对在服务上或通过服务提交、张贴、传输或展示的任何内容的任何权利、所有权或利益，包括该内容中存在的任何知识产权（无论该等权利是否已经登记，亦不论该等权利在世界的何等地方存在）。除非您与小惠医生另有书面协议，否则您同意您负责保护并强制执行这些权利，小惠医生没有义务代表您这样做。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （九）您同意您不得删除、掩藏或改动服务所附的或包含的任何专有权利声明（包括著作权和商标声明）。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （十）除非您得到小惠医生书面明确授权这样做，否则您同意在使用服务时，您将不以可能或故意导致混淆该等商标、名称或标识的所有者或授权用户的方式使用任何公司或组织的商标、服务标识、商号、标识。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    六、侵权举报
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）小惠医生高度重视自由表达和个人、企业正当权利的平衡。依照法律规定删除违法信息是小惠医生的法定义务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）侵犯企业或个人合法权益的侵权举报，包括但不限于涉及个人隐私、造谣与诽谤、商业侵权。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 涉及个人隐私：发布内容中直接涉及身份信息，如个人姓名、家庭住址、身份证号码、工作单位、私人电话、健康信息等详细个人隐私；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 造谣、诽谤：发布内容中指名道姓（包括自然人和企业）的直接谩骂、侮辱、虚构中伤、恶意诽谤等；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 商业侵权：泄露企业商业机密及其他根据保密协议不能公开讨论的内容。


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）用户在小惠医生发表的内容仅表明其个人的立场和观点，并不代表小惠医生的立场或观点。如果个人或企业发现小惠医生上存在侵犯自身合法权益的内容，可以先尝试与作者取得联系，通过沟通协商解决问题。如您无法联系到作者，或无法通过与作者沟通解决问题，您可通过向小惠医生指定邮箱发送侵权投诉内容至邮箱hmkefu@huimeihealth.com进行投诉。为了保证问题能够及时有效地处理，请务必提交真实有效、完整清晰的材料，否则投诉将无法受理。您需要向小惠医生提供的投诉材料包括：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 权利人对涉嫌侵权内容拥有商标权、著作权和/或其他依法可以行使权利的权属证明，权属证明通常是营业执照或组织机构代码证；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    2. 举报人的身份证明，身份证明可以是身份证或护照；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 如果举报人非权利人，请举报人提供代表权利人进行举报的书面授权证明。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为确保投诉材料的真实性，在侵权举报中，您还需要出具以下法律声明：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 我本人为所举报内容的合法权利人；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 我举报的发布在小惠医生中的内容侵犯了本人相应的合法权益；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 如果本侵权举报内容不完全属实，本人将承担由此产生的一切法律责任，并承担和赔偿小惠医生因根据投诉人的通知书对相关帐号的处理而造成的任何损失，包括但不限于小惠医生因向被投诉方赔偿而产生的损失及小惠医生名誉、商誉损害等。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）处理流程
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 出于网络平台的监督属性，并非所有申请都必须受理。小惠医生自收到举报的七个工作日内处理。处理期间，不提供任何电话、邮件及其他方式的查询服务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 此为小惠医生唯一的官方侵权投诉渠道，暂不提供其他方式处理此业务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 用户在小惠医生中因用户互动所引发的法律纠纷，由用户双方自行处理，与小惠医生无关。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    七、终止您与小惠医生的关系
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）如果您希望终止与使用小惠医生产品及服务的，您可以通过【小惠医生隐私权政策】中规定的方式注销账号及相关使用信息。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）发生下列情况时小惠医生可单方终止其与您的服务关系及相关协议约定：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 您违反了本条款的任何规定（或您的行为方式明确显示您不打算或不能遵守本条款规定）；或
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    2. 法律要求小惠医生这样做（例如：向您提供服务不合法或变得不合法）；或
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 小惠医生与之一起向您提供服务的合作伙伴已终止与小惠医生的关系或停止向您提供服务；或
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4. 小惠医生转变为不再向您居住的或您从那里使用服务的国家内的用户提供服务；或
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    5. 小惠医生认为，小惠医生向您提供服务不再具有商业可行性。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）本条款终止时，您和小惠医生已经享受或承担的（或在本条款有效期间已经产生的）或明确规定为无限期有效的所有法定权利、义务和责任不受该终止的影响。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）小惠医生、其子公司和关联公司及其许可人，不就以下各项向您作出陈述或保证：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 您对服务的使用将符合您的需求；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 您对服务的使用将无中断、及时、安全或没有错误；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. 由于您使用服务而获得的任何信息将是准确的或可靠的；及
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4. 作为服务的一部分向您提供的任何软件的运行或功能中的缺陷将被纠正。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （五）通过使用服务而下载或以其他方式获得的任何材料由您自行作出并承担风险，您将独自对由于下载任何该等材料而导致对电脑系统或其他装置的损害或数据的丢失负责。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （六）您从小惠医生获得的或通过服务或从服务获得的任何建议或信息（无论口头还是书面的）均不创立本条款中未明确规定的任何保证。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （七）小惠医生进一步明确否认任何种类的所有保证和条件（无论明示还是默示的），包括但不限于适销性、适合特定目的及不侵权的默示保证和条件。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    八、责任限制
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）在遵守本协议全部规定的前提下，您明示理解并同意，小惠医生和关联公司及其许可人不就以下事项对您承担责任：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 您无论由于何种原因和在任何责任理论项下发生的任何直接、间接、附带、特殊、后果性或惩罚性的损害。这应包括但不限于任何利润损失（无论是直接还是间接发生）、任何商誉或业务声誉损失、任何数据丢失、替代物品或服务的购买费用或其他无形损失；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 前文所述您可能产生的任何损失或损害，包括但不限于由下列原因导致的损失或损害：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (1) 您对任何广告的完整性、准确性或其存在的信任，或作为您与其广告出现在服务中的任何广告商或赞助人之间的任何关系或交易的结果；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (2) 小惠医生对服务可能做出的变更，或永久或暂时停止提供服务（或服务中的任何功能）；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (3) 对通过您使用服务而维持或传输的任何内容及其他通信数据的删除、毁坏或未能将其储存；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (4) 您未向小惠医生提供准确的帐户信息；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (5) 您未对您的密码或帐户资料保持安全及保密。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    无论小惠医生是否接到通知或是否应已知晓引起任何该等损失的可能性，上文第1款中小惠医生对您的责任限制均应适用。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）对关于符合适用国际知识产权法（包括中国的《著作权法》）的指称的著作权侵权通知做出回应以及终止重复侵权者帐户是小惠医生的政策。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）小惠医生不能对用户发表的回答或评论的正确性进行保证。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）用户在小惠医生发表的内容仅表明其个人的立场和观点，并不代表小惠医生的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。小惠医生不承担任何法律及连带责任。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （五）小惠医生不保证网络服务一定能满足用户的要求，也不保证网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作保证。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （六）对于因不可抗力或小惠医生不能控制的原因造成的网络服务中断或其它缺陷，小惠医生不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。
                                </div>


                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    九、 其他内容
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）服务可包含对其他平台或内容或资源的超级链接。小惠医生可能并不控制由小惠医生以外的公司或个人提供的任何平台或资源。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）您认知并同意，小惠医生不对该等外部平台或资源的可用性负责，亦不对该等网络或资源上的或从该等平台或资源获得的任何广告、产品或其他材料加以认可。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）您认知并同意，小惠医生不对由于您由于那些外部的平台或资源的可用性或您对该等平台或资源上的或从该等平台或资源获得的任何广告、产品或其他材料的完整性、准确性或存在的信赖而发生的任何损失或损害承担责任。
                                </div>



                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    十、本协议的变更
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）小惠医生可不时对通用条款或附加条款作出变更，不再另行通知。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）您理解并同意，如果您在通用条款或附加条款变更日期之后使用服务，则小惠医生将把您的使用视为接受更新后的通用条款或附加条款。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    十一、一般法律条款

                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）本协议及本协议条款项下您与小惠医生的关系，受中国法律管辖，但排除其冲突法规定。您与小惠医生均同意接受位于中国境内的银川市兴庆区人民法院的管辖，以解决任何由本条款引起的法律事项。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）本协议内容中的条款，请您着重阅读。您点击“同意”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
                                </div>
                                <br />
                                <div className={`${styles.item} ${styles.no_indent}`} style={{ textAlign: 'right' }}>
                                    银川惠每数科互联网医院有限公司
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`} style={{ textAlign: 'right' }}>
                                    2023年2月20日
                                </div>

                            </div>
                            <div className={`${styles.text_gap}`}>
                            </div>
                        </div>
                        :
                        <div className={`${styles.aggreement_content}`}>
                            <div className={`${styles.section}`}>
                                <div className={`${styles.title} ${styles.no_indent}`}>
                                    小惠医生隐私权政策
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`} style={{ textAlign: 'right' }}>
                                    最近更新日期：2023年2月20日
                                </div>
                                <br />

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    特别提示
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    尊敬的小惠医生用户：本隐私权政策旨在协助您了解我们会如何处理、共享、转让、公开披露您的个人信息、为什么收集这些信息，以及您如何访问和管理自己的信息。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    接受条款
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您的信任对我们非常重要，我们深知个人信息安全的重要性，我们将会按照法律法规要求，采取安全保护措施保护您的个人信息安全。鉴此，小惠医生服务提供者（或简称“我们”）制定本《隐私权政策》并提醒您：


                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    本政策适用于小惠医生的各项服务或产品。如我们及/或关联公司（范围详见定义部分）的服务或产品中使用了小惠医生提供的服务或产品（例如直接使用小惠医生账户登录）但未设独立隐私权政策的，则本政策同样适用于该部分服务或产品。我们及/或关联公司就其向您提供的产品或服务单独设立隐私权政策的，则相应产品或服务适用该相应的隐私权政策。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请您注意，本政策不适用由其他公司或个人（以下简称“第三方”）提供的服务。如您使用该等第三方服务须受该第三方隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。我们不参与且不对您与第三方之间因个人信息保护等发生的纠纷承担任何责任。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请您在使用小惠医生各项服务或产品前，务必仔细阅读并透彻理解本政策，特别是以粗体标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。在任何情况下，您的使用行为将被视为对本政策全部内容的认可。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    如您对本政策内容有任何疑问、意见或建议，您可通过本政策提供的各种联系方式与我们联系。
                                </div>


                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    第一部分定义
                                </div>
                                <div className={`${styles.item}`}>
                                    小惠医生：指我们开发、运营的，协助患者整合线下医生及互联网医院（线上医生）服务、管理自身健康记录、用药管理、就诊服务等医疗服务的互联网产品；
                                </div>
                                <div className={`${styles.item}`}>
                                    小惠医生服务提供者：指小惠医生的软件技术服务提供者银川惠每数科互联网医院有限公司。
                                </div>
                                <div className={`${styles.item}`}>
                                    关联公司：指银川惠每数科互联网医院有限公司及其在中国境内设立或运营的实体，包括其直接或间接控股的公司，参股或形成经营、协作的具有关联关系的企业。
                                </div>
                                <div className={`${styles.item}`}>
                                    用户：指小惠医生产品或服务的使用人，在本政策中被称为“您”或“用户”。
                                </div>
                                <div className={`${styles.item}`}>
                                    个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
                                </div>
                                <div className={`${styles.item}`}>
                                    个人敏感信息：指包括身份证件号码、个人生物识别信息、用药记录、交易信息、健康情况、14岁以下（含）儿童信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。
                                </div>
                                <div className={`${styles.item}`}>
                                    个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
                                </div>
                                <div className={`${styles.item}`}>
                                    儿童：指不满十四周岁的未成年人。
                                </div>



                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    第二部分隐私权政策
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    本隐私权政策部分将帮助您了解以下内容：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    一、我们如何收集和使用您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    二、我们如何使用 Cookie 和同类技术
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    三、信息存储
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    四、我们如何保护您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    五、我们如何委托处理、共享、转让、公开披露您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    六、您的权利
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    七、我们如何处理未成年人的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    八、您的个人信息如何在全球范围转移
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    九、本政策如何更新
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    十、如何联系我们
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    一、我们如何收集和使用您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    在您使用小惠医生的产品/服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. 为实现向您提供小惠医生产品/服务的基本功能，您需授权我们收集、使用的必要个人信息。如您拒绝提供相应信息，您将无法正常使用小惠医生的产品/服务。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. 为实现向您提供小惠医生产品/服务的附加功能，您可选择是否授权我们收集、使用的个人信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们会为实现本政策所述的以下功能，收集和使用您的个人信息：

                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （一）为您提供注册与认证功能
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您需要注册一个账户，以便于我们为您提供服务。当您注册时，请您至少提供手机号码，我们将通过发送手机信息验证码的方式验证您的身份是否有效。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您的登录名是您的手机号，您可以完善生日、性别等个人信息，补充这些“账户信息”将有助于我们为您提供更具个性化的服务。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您可能需要根据小惠医生页面提示向我们提供真实姓名和身份证号码，以便于我们进行实名（实人）认证。如果您不提供这些信息，可能会影响您对小惠医生部分核心业务功能的正常使用，但不会影响您进行基本的浏览、搜索。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    授权登录：您注册小惠医生账户后，我们可能经您同意后向我们的关联公司共享您的账户信息（头像、昵称及其他页面提示的信息），您可通过同一账号在我们提供的链接入口使用我们关联公司提供的服务或产品。此外，我们可能从第三方获取您授权共享的第三方账户信息（如头像、昵称、联系方式等），并将您的第三方账户与您的小惠医生账户绑定，使您可以通过第三方账户直接登录并使用小惠医生的服务或产品。我们将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （二）为您提供产品/服务信息展示与定向推送功能
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为向您提供更契合您需求的页面展示和搜索结果、了解产品适配性，我们会收集关于您使用的服务以及使用方式的信息并将这些信息进行关联，这些信息包括：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、Android id、MAC地址、IMEI、IMSI、唯一设备标识符这类软硬件特征信息）、设备所在位置相关信息（包括IP 地址、GPS位置以及能够提供相关信息的Wi-Fi 接入点、蓝牙和基站这类传感器信息）。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    日志信息：当您使用我们的网站或客户端等提供的服务或产品时，我们会自动收集您对小惠医生服务的详细使用情况，作为有关网络日志保存，包括您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为改善小惠医生的产品或服务、向您提供更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的浏览及搜索记录、设备信息、位置信息、关联医生等，提取您的浏览、搜索偏好、行为习惯、位置信息等特征，基于特征标签进行间接人群画像并展示、推送信息。

                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （三）为您提供整合线下医生及互联网医院、管理自身健康记录、用药管理、就诊服务功能（患者端）
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    当您使用小惠医生的医疗服务时，我们可能会申请开启您的位置信息（地理位置）、相机/摄像头、麦克风（语音）以及存储的相关权限；同时可能邀请您上传您的病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史及其他个人健康生理信息，以及个人身体健康状况产生的体重、身高、肺活量和其他相关个人敏感信息，以供您用于上述服务。在提供前述个人敏感信息之前，您需确保相关个人信息属于自身所有并同意授权予小惠医生提供给线下医生及互联网医院使用；其中涉及儿童个人信息的，您需在提供前征得该儿童监护人的同意。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （四）为您提供客户服务
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。

                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （五）为您提供安全保障
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或小惠医生相关协议规则的情况，我们可能使用或整合您的账户信息、交易信息、设备信息（包括设备型号、操作系统版本、设备设置、Android id、MAC地址、IMEI、IMSI、唯一设备标识符、已安装应用软件列表、最近运行的应用这类软硬件特征信息）、设备所在位置相关信息（包括IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站这类传感器信息）、日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （六）设备权限调用
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为向您提供便捷、优质的服务，我们可能会调用您设备的一些权限，以下是我们可能调用的设备权限列表及对应的使用目的说明，您有权随时选择关闭下列权限的授权，但可能会影响您正常使用小惠医生服务或产品的部分或全部功能。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    以下权限说明依照下列格式呈现：[设备权限]-对应业务功能-/调用权限的目的/-[是否询问]-|可否关闭权限|-（如果关闭权限会影响用户什么功能）
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. [位置]- 用于基于位置的药店、医院信息展示、推送 -/通过用户当前位置，优化用户搜索等信息展示推荐/-[用户首次打开移动客户端时会弹窗询问]-|是|-（用户将无法准确使用基于位置的医疗信息展示推荐）
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. [相机]-核心业务功能-/1、上传个人信息、病史信息、诊断信息和检测报告等个人健康信息时拍摄并上传照片2、上传报告 /-[用户点击拍照功能时会弹窗询问]-|是|-（用户无法正常使上传病历报告功能）
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. [剪切板]-全部-/根据您的主动点选使用剪贴板功能辅助您的操作，使用粘贴功能智能填写地址信息、一键复制快速分享图文信息 /-[iOS 系统调用时有响应提示]-|是|-（无法智能填写地址信息、无法一键复制快速分享图文信息，但不影响主要功能）
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （七）其他
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策规定的途径联系我们，要求更正或删除涉及儿童个人信息的内容。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、征得授权同意的例外
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （1）与国家安全、国防安全有关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （2）与公共安全、公共卫生、重大公共利益有关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （3）与犯罪侦查、起诉、审判和判决执行等有关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （5）所收集的个人信息是您自行向社会公众公开的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （7）根据您的要求签订合同所必需的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （9）为合法的新闻报道所必需的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （11）法律法规规定的其他情形。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善小惠医生平台的内容和布局，为商业决策提供产品或服务支撑，以及改进小惠医生的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4、如我们停止运营小惠医生，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    二、我们如何使用 Cookie 和同类技术
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （一） Cookie
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为确保小惠医生的正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，小惠医生能够记住您的选择，提供个性化增强服务等。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您可根据自己的偏好管理或删除Cookie。有关详情，请参见 AboutCookies.org。您可以清除手机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问小惠医生平台时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （二）网站信标和像素标签
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    除 Cookie 外，我们还会在小惠医生上使用平台信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至小惠医生内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    三、信息存储
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （一）存储地点
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您知晓并同意，您在使用小惠医生产品、服务期间所产生的有关您的信息存储在中国境内安全可信的服务器上。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （二）存储期限
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们仅在实现本政策所述目的所必需的时间内保留您的个人信息。在您与我们之间的合同关系（客户关系）存续期间，我们会处理并保存您的数据。当您注销小惠医生账户后，我们将对您的帐号信息进行删除或匿名化处理，但法律法规另有规定或者您另行授权同意的除外。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    四、我们如何保护您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （一）我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术（例如，SSL/TLS）、匿名化处理等手段来保护你的个人数据。目前，我们的重要信息系统已通过信息安全等级保护（三级）测评和备案，在信息安全方面已通过ISO27001认证。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （二）我们已建立专门的管理系统、流程和组织，确保信息安全。例如，我们严格限制有信息访问权限的人员，要求这些人员遵循其保密义务，并对此进行审查。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （四）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过小惠医生上的公告方式获得。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （五）互联网并非绝对安全的环境，我们强烈建议您不要使用非小惠医生推荐的通信方式发送个人信息。请注意，您在使用小惠医生服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用小惠医生服务时共享甚至公开分享相关信息。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请您妥善保护自己及患者的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络客服，以便我们根据您的申请采取相应措施。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    （六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    五、我们如何委托处理、共享、转让、公开披露您的个人信息

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （一）委托处理
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    小惠医生的全部业务功能均由我们自行提供。如后续某些具体的模块或功能由外部供应商提供的，对我们委托处理个人信息的该等外部供应商，我们会与其签署严格的保密协定，要求他们按照我们的要求、本政策以及其他任何相关的保密和安全措施来处理个人信息。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （二）共享
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们不会与小惠医生服务提供者以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、在法定情形下的共享：我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。

                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、与关联公司间共享：为便于我们基于小惠医生账号向您提供产品或服务，推荐您可能感兴趣的信息或保护本政策所定义的关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与关联公司共享。例如，为了更好地查看、管理患者的健康档案，您获得患者同意将小惠医生患者的个人敏感信息，包括体检报告上传至小惠医生小程序。

                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您订购我们的商品时，我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与金融机构共享以实现其确认您的支付指令并完成支付等。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    目前，我们的授权合作伙伴包括以下类型：

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (1）广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您。例如，只有在广告主同意遵守我们的广告发布准则后，我们才可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别个人身份的人口统计信息（例如“位于北京的25岁男性，有吸烟习惯”），帮助他们了解其受众或顾客。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    (2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、安全保障服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    为了使您能够使用本政策项下的各项服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序，其中可能会涉及传输相关个人信息，具体如下：

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    以下权限说明依照下列格式呈现：[功能类型]-SDK名称-/使用目的/-[个人信息类型]-|个人信息字段|-（数据是否去标识化传输）-《隐私权政策链接》

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1. [第三方登录及分享]-微信SDK-/第三方登录积分项/-[个人常用设备信息]-|设备信息|-（是）-《https://www.tencent.com/zh-cn/privacy-policy.html》

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2. [系统运营]-腾讯Bugly SDK-/系统异常上报/-[个人常用设备信息]-|设备信息、获取网络状态|-（是）-《https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf》

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3. [基础代码库]-腾讯Mars-/框架/工具/-[个人常用设备信息]-|设备信息、WIFI的SSID、WIFI的BSSID、WIFI的信号强度、wifi状态信息、wifi Mac地址、获取安装应用信息|-（是）-《https://github.com/Tencent/mars》

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4. [基础代码库]-腾讯浏览服务-/内容浏览/-[个人常用设备信息]-|设备信息（IMEI、IMSI、MAC地址）、用户机型、屏幕尺寸、操作系统版本号、目标API（targetAPI）、网络类型（ApnType）、网络边户监听广播、WiFi的MAC地址、获取网络状态、wifi状态信息、wifi Mac地址|-（是）-《https://www.tencent.com/zh-cn/privacy-policy.html》

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。

                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （三）转让
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、在小惠医生服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （四）公开披露
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们仅会在以下情况下，公开披露您的个人信息：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、获得您明确同意；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、如果我们确定您出现违反法律法规或严重违反小惠医生相关协议规则的情况，或为保护我们及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或小惠医生相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及小惠医生已对您采取的措施。例如，若您囤积号源、虚假预约而严重违反用户协议，我们可能会公开披露或与合作方共享您的身份信息、联系方式与处罚情况。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （五）共享、转让、公开披露个人信息时事先征得授权同意的例外

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、与个人信息控制者履行法律法规规定的义务相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、与国家安全、国防安全直接相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、与公共安全、公共卫生、重大公共利益直接相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、与刑事侦查、起诉、审判和判决执行等直接相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    5、您自行向社会公众公开的个人信息；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。

                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    六、您的权利
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您可以通过以下方式访问及管理您的个人信息：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （一）访问您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    如果您希望访问或编辑您的账户中的个人基本资料信息和实名认证信息、更改您的密码或添加绑定邮箱等，您可以随时通过客服邮箱hmkefu@huimeihealth.com.cn与我们取得联系。我们将在15个工作日内回复您的访问请求。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    对于您在使用小惠医生的服务或产品过程中产生的其他个人信息，只要我们不需要过多投入，我们将根据本条“响应您的上述请求”中的相关安排向您提供。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （二）更正您的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过本条“访问您的个人信息”中列明的方式提出更正申请。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （三）删除您的个人信息

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您可以通过本条“访问您的个人信息”中列明的方式删除您的部分个人信息。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    在以下情形中，您可以向我们提出删除个人信息的请求：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、如果我们处理个人信息的行为违反法律法规；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、如果我们收集、使用您的个人信息，却未征得您的明确同意；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、如果我们处理个人信息的行为严重违反了与您的约定；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4、如果您不再使用小惠医生的产品或服务，或您主动注销了账号；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    5、如果我们永久不再为您提供产品或服务。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    当您从小惠医生的服务中删除信息或我们协助您删除相关信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    通常情况下，为确保优质的互联网医疗服务，您通过使用本服务而形成的诊疗记录可能无法被随意更改或者删除。您理解并且同意，为了满足相关法律法规的要求，或者为了保存诊疗、用药记录、证据的目的，我们可能无法完全删除您的诊疗记录(包括但不限于视频诊疗和处方记录)，但是我们将不再对该等记录信息进行商业利用。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （四）改变您授权同意的范围
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您可以通过删除信息、关闭设备功能、在小惠医生上进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    请您理解，（见本隐私权政策“我们如何收集和使用您的信息”）。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （五）注销您的账户
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您可通过联系客服邮箱hmkefu@huimeihealth.com.cn来完成账户注销流程。请您谨慎操作，否则，因账户注销产生的数据丢失问题均由您自行承担。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    在符合小惠医生单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项小惠医生服务账号可能被注销或删除。当账号注销或被删除后，与该账号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或匿名化处理，但法律法规另有规定的除外。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，但法律法规另有规定的除外。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （六）获取个人信息副本
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    您如果有获取您的个人信息副本的需求的，您可以通过本政策第十条所述方式联系我们，我们将逐一处理，将您的个人信息副本传输给您指定的第三方。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （七）约束信息系统自动决策
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    在某些互联网电子服务或产品中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我们和关联公司商业秘密或用户权益、社会公共利益的前提下提供申诉方法。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    （八）响应您的上述请求
                                </div>

                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    如您需要撤销授权信息或者注销、删除个人账号信息，您可通过本政策第十条约定的方式联系我们。为保障您的信息安全，我们可能需要您提供书面请求或其他方式证明您的身份，验证通过后即可处理您的请求。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们将会在15 个工作日内针对您的的请求做出答复。如您不满意，可通过客服中心发起投诉。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    在以下情形中，按照法律法规要求，我们将无法响应您的请求：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、与个人信息控制者履行法律法规规定的义务相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、与国家安全、国防安全直接相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、与公共安全、公共卫生、重大公共利益直接相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4、与刑事侦查、起诉、审判和执行判决等直接相关的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    5、者有充分证据表明您存在主观恶意或滥用权利的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    6、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    7、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；

                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    8、涉及商业秘密的。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    七、我们如何处理未成年人的个人信息
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人的，我们要求您请您的父母或监护人仔细阅读本政策，并在征得您的父母或监护人同意的前提下使用小惠医生的服务或产品或向我们提供信息。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    对于经父母或监护人同意使用小惠医生的服务或产品而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    根据当地监管部门的相关规定，小惠医生仅对满足特定年龄要求的用户提供互联网电子服务或产品。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    八、您的个人信息如何在全球范围转移
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、法律法规有明确规定；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、获得您的明确授权；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、您通过互联网进行海外互联网电子服务或商品等个人主动行为。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    针对以上情形，我们会确保依据本政策对您的个人信息提供足够的保护。
                                </div>

                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    九、本政策如何更新
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    我们的隐私权政策可能变更。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    未经您明确同意，我们不会削减您按照本政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    对于重大变更，我们还会提供更为显著的通知（包括我们会通过在小惠医生上公示的方式进行通知甚至向您提供弹窗提示）。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    本政策所指的重大变更主要包括以下情形：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    3、个人信息共享、转让或公开披露的主要对象发生变化；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    6、个人信息安全影响评估报告表明存在高风险时。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    若您无法同意变更后的政策内容，您应立即停止使用本服务。如您继续登录本平台，则视为您同意经修改的政策。
                                </div>
                                <div className={`${styles.item} ${styles.no_indent} ${styles.p_title}`}>
                                    十、如何联系我们
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    如您对本政策内容有任何疑问、意见或建议，或发现个人信息可能被泄露的，您可以通过以下方式与我们联系，一般情况下我们将在15个工作日内回复您的请求：
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    1、您可以随时通过客服邮箱hmkefu@huimeihealth.com.cn我们联系；
                                </div>
                                <div className={`${styles.item} ${styles.no_indent}`}>
                                    如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向本政策签订地（上海市徐汇区）有管辖权的法院提起诉讼来寻求解决方案。
                                </div>
                            </div>
                            <div className={`${styles.text_gap}`}></div>
                        </div>
                }
            </div>
        </div>
    )

}

export default Privacy;